import { H6, Paragraph, Progress, SizableText, XStack, YStack } from 'tamagui'
import { formatCurrency } from '@/src/common/utils/general'

export function TrackYourSpend({
  spendAmount,
  thresholdAmount,
}: {
  spendAmount: number
  thresholdAmount: number
}) {
  const percentageSpend = Math.min(spendAmount / Math.max(thresholdAmount, 1), 1)
  const formattedSpendAmount = formatCurrency(spendAmount.toString(), {
    isFloat: true,
    minimumFractionDigits: 0,
    decimals: null,
  })
  const formattedThresholdAmount = formatCurrency(thresholdAmount.toString(), {
    isFloat: true,
    minimumFractionDigits: 0,
    decimals: null,
  })
  return (
    <YStack gap="$2" flex={1}>
      <XStack justify="space-between">
        <H6>Track Your Spend</H6>
        <H6>
          {formattedSpendAmount} / {formattedThresholdAmount}
        </H6>
      </XStack>
      <Progress bg="$border" size="$4" value={percentageSpend * 100}>
        <Progress.Indicator bg="$secondary" animation="bouncy" />
      </Progress>
      <Paragraph>
        <SizableText size="$3" opacity={0.75}>
          Make at least {formattedThresholdAmount} in eligible purchases within your current
          statement cycle to earn.
        </SizableText>
      </Paragraph>
    </YStack>
  )
}
